import { combineReducers } from "redux";
import { arboristLogin } from "./arboristLogin";
import {client} from "./client";
import { property } from "./property";
import { report } from "./report";
import { tree } from "./tree";
import {arbor} from "./company"

export default combineReducers({ arboristLogin, client, property, report, tree ,arbor});